'use client';

import { c as _c } from "react/compiler-runtime";
import CourseFinishedCard from './HeroAsideCards/CourseFinishedCard';
import CourseInProgressCard from './HeroAsideCards/CourseInProgressCard';
import HeroAsset from './HeroAsset';
import { useCourseContext } from '../../_contexts/CourseContext';
export default function HeroAside() {
  const $ = _c(8);
  const {
    course,
    learningOutcomes
  } = useCourseContext();
  const progression = course?.userCourseCompletionRate;
  const isCourseFinished = progression === 100;
  const learningActivityStatus = course?.learningActivityStatus;
  const userIsFollowingCourse = course?.userIsFollowingCourse;
  if (progression !== null && (learningActivityStatus === "in_progress" || userIsFollowingCourse)) {
    if (isCourseFinished) {
      let t0;
      if ($[0] !== learningOutcomes || $[1] !== progression) {
        t0 = <CourseFinishedCard progression={progression} learningOutcomes={learningOutcomes} />;
        $[0] = learningOutcomes;
        $[1] = progression;
        $[2] = t0;
      } else {
        t0 = $[2];
      }
      return t0;
    }
    let t0;
    if ($[3] !== learningOutcomes || $[4] !== progression) {
      t0 = <CourseInProgressCard progression={progression} learningOutcomes={learningOutcomes} />;
      $[3] = learningOutcomes;
      $[4] = progression;
      $[5] = t0;
    } else {
      t0 = $[5];
    }
    return t0;
  }
  let t0;
  if ($[6] !== course) {
    t0 = <HeroAsset course={course} />;
    $[6] = course;
    $[7] = t0;
  } else {
    t0 = $[7];
  }
  return t0;
}